export default class Settings
{
	static keysWithDefaults = Object.freeze({
    // Local storage keys
		"AUTH_TOKEN": null,
		"LANGUAGE": "sv",
		"CASE_ID": null,
		"LAST_VIEW": null,
		"FA_SSN": null,
		"ACTIVE_ADVISOR": null,
    "TAGS_LAST_USED": [],
    // Session storage keys
		"SHOW_SESSION_TIMEOUT_MODAL": false,
	});

  static exposedKeys = Object.freeze([ // Keys that can be stored as plain text
    "LANGUAGE",
    "SHOW_SESSION_TIMEOUT_MODAL",
    "TAGS_LAST_USED"
  ]);

  static persistentKeys = Object.freeze([ // Keys that should persist even on clear()
    "SHOW_SESSION_TIMEOUT_MODAL",
    "TAGS_LAST_USED"
  ]);

	static get(key)
	{
		try
		{
			if (typeof Settings.keysWithDefaults[key] === "undefined")
			{
				throw new Error("UNKNOWN_KEY");
			}

			let value = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (value === null) {
        return Settings.keysWithDefaults[key];
      }

      return Settings.exposedKeys.includes(key)
        ? JSON.parse(value)
        : JSON.parse(atob(value));
		} catch (e)
		{
			console.error({status: e, key});
		}
	}

	static set(key, value, type = "storage")
	{
		try
		{
			if (typeof Settings.keysWithDefaults[key] === "undefined")
			{
				throw new Error("UNKNOWN_KEY");
			}

      const json = JSON.stringify(value);

      if (type === "storage") {
        localStorage.setItem(key, Settings.exposedKeys.includes(key) ? json : btoa(json));
      } else if (type === "session") {
        sessionStorage.setItem(key, Settings.exposedKeys.includes(key) ? json : btoa(json));
      }
		} catch (e)
		{
			console.error({status: e, key});
		}
	}

	static remove(key)
	{
		localStorage.removeItem(key);
	}

	static clear()
	{
		for (const key in Settings.keysWithDefaults)
		{
			if (!Settings.persistentKeys.includes(key))
			{
				localStorage.removeItem(key);
        sessionStorage.removeItem(key);
			}
		}
	}
}